import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Pagination from '../../components/common/Pagination';
import Spinner from '../common/Spinner';

export default class GridContainerProduct extends PureComponent {
  render() {
    const { isLoading, pageCount, children, handlePageClick, currentPage } = this.props;

    return isLoading ? (
      <Spinner />
    ) : (
      <div className="column_products">
        <div className="row vertical-indent empty">{children}</div>

        <Pagination pageCount={pageCount} handlePageClick={handlePageClick} currentPage={currentPage} />
      </div>
    );
  }
}

GridContainerProduct.defaultProps = {
  children: PropTypes.array,
  pageCount: 0,
  handlePageClick: PropTypes.func,
  isLoading: false,
};

GridContainerProduct.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array.isRequired, PropTypes.element.isRequired]),
  pageCount: PropTypes.number,
  handlePageClick: PropTypes.func,
  currentPage: PropTypes.number.isRequired,
  isLoading: PropTypes.bool,
};
